const setAnswer = function (qu, valueMap, otherAnswerMap) {
  this.descList.forEach(item => {
    item.tmpValue = getAnswerValue(item, this.scoreQuType, valueMap, otherAnswerMap)
    item.value = getAnswerValue(item, this.scoreQuType, valueMap, otherAnswerMap)
  })
}

const getAnswerValue = (item, scoreQuType, valueMap, otherAnswerMap) => {
  let value = valueMap[item.id]
  if (value instanceof Array && value.length === 1) {
    value = value[0]
  }
  if (scoreQuType === '1' || scoreQuType === '5') {
    value = value || ''
  } else {
    value = value || null
  }
  return value
}

const answer = {
  setAnswer
}

export default answer



// WEBPACK FOOTER //
// ./src/components/editor/RateGroupBox/answer.js